import React from 'react';
import BookingConfirmationDocument from "./BookingConfirmationDocument";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";


const BookingDocuments = ({booking}) => {
    return <Box p={2}>
        <Divider sx={{my: 2}}/>
        <BookingConfirmationDocument booking={booking}/>
        <Divider sx={{my: 2}}/>
    </Box>;
}

export default BookingDocuments;